<template>
  <div class="row">
    <div :class="['col_12', {'loading_overlay': loading}]">
      <div class="card no_border">
        <div class="card-header">
          <div class="card-title">{{ pageName }}</div>
        </div>
        <div class="card-body pl_0 pr_0">
          <div class="row">
            <div class="col_3">
              <div class="form-group ">
                  <label>{{ $t('common.name') }}</label>
                  <input type="text" class="form_global"  v-model="form.name">
                  <v-errors :errors="errorFor('name')"></v-errors>
              </div>
            </div>
            <div class="col_3">
              <div class="form-group ">
                  <label>{{ $t('common.phone') }}</label>
                  <input type="text" class="form_global"  v-model="form.phone">
                  <v-errors :errors="errorFor('phone')"></v-errors>
              </div>
            </div>
            <div class="col_3">
              <div class="form-group ">
                  <label>{{ $t('common.email') }}</label>
                  <input type="email" class="form_global"  v-model="form.email">
                  <v-errors :errors="errorFor('email')"></v-errors>
              </div>
            </div>
            <div class="col_3">
              <div class="form-group ">
                  <label>{{ $t('sidebar.professorMember.qualification') }}</label>
                  <input type="text" class="form_global"  v-model="form.qualification">
                  <v-errors :errors="errorFor('qualification')"></v-errors>
              </div>
            </div>
            <div class="col_3">
              <div class="form-group ">
                  <label>{{ $t('common.address') }}</label>
                  <input type="text" class="form_global"  v-model="form.address">
                  <v-errors :errors="errorFor('address')"></v-errors>
              </div>
            </div>
            <div class="col_3">
              <div class="form-group ">
                  <label>{{ $t('common.photo') }}</label>
                  <input type="file" class="form_global" ref="photo" @input="onFileChange($event)" accept="image/png, image/gif, image/jpeg, image/webp">
                  <v-errors :errors="errorFor('photo')"></v-errors>
                  <div class="video_list mt_10" v-if="tempPhoto || form.photo">
                    <div class="inner">
                        <div class="inner_wrap">
                          <img v-if="tempPhoto" :src="tempPhoto" alt="">
                          <img v-else :src="form.photo" alt="">
                            <div class="icons">
                                <span @click.prevent="removeTempPhoto()"><i class="lni lni-trash"></i></span>
                            </div>
                        </div>
                    </div>
                  </div>
              </div>
            </div>
            <div class="col_3">
              <div :class="['form-group', {'has_error': errorFor('status')}]">
                  <label>{{ $t('common.status') }}</label>
                  <div class="form_inline">
                    <div class="form_radio">
                      <input type="radio" id="active" name="status" value="1" v-model="form.status">
                      <label for="active">{{ $t('common.active') }}</label>
                    </div>
                    <div class="form_radio">
                      <input type="radio" id="inactive" name="status" value="0" v-model="form.status">
                      <label for="inactive">{{ $t('common.inactive') }}</label>
                    </div>
                  </div>
                  <v-errors :errors="errorFor('status')" />
                </div>
            </div>
          </div>
          <div class="d_flex_end form_action_btn">
            <router-link class="btn btn_danger ml_10" :to="{name: cancelRouteName}">{{ $t('common.cancel') }}</router-link>
            <button class="btn btn_blue ml_10" @click.prevent="submitForm">{{ $t('common.save') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'professor-form',
  components: {},
  data() {
    return {
      pageName: this.$t('sidebar.professorMember.addProfessor'),
      cancelRouteName: 'professor_list',
      form: {
        name: '',
        phone: '',
        email: '',
        qualification: '',
        address: '',
        photo: '',
        status: 1,
      },
      tempPhoto:'',
    }
  },
  created() {
    if (this.$route.name === 'professor_edit') {
      this.axios.get('/professors/'+this.$route.params.id)
        .then((response) => {
          let editData = response.data.data;
          this.form.name = editData.name
          this.form.phone = editData.phone
          this.form.email = editData.email
          this.form.qualification = editData.qualification
          this.form.address = editData.address
          this.form.photo = editData.photo
          this.form.status = editData.status
        })
      this.pageName = this.$t('sidebar.professorMember.editProfessor');
    }
  },
  methods: {
    onFileChange(e){
      this.form.photo = e.target.files[0]
      this.tempPhoto = URL.createObjectURL(e.target.files[0]);
    },
    removeTempPhoto(){
      this.tempPhoto = ''
      this.form.photo = ''
      this.$refs.photo.value = null;
    },
    submitForm() {
        this.allErrors = null;
        this.loading = true;

        let formData = new FormData()

        Object.keys(this.form).forEach(key => {
            formData.append(key, this.form[key] ? this.form[key] : '');
        })

        if (this.$route.name === 'professor_edit') {
          formData.append('_method','PATCH')

          this.axios.post('/professors/'+this.$route.params.id, formData,{
            headers: {
                'Content-Type': 'multipart/form-data'
            },
          })
          .then(() => {
            this.$router.push({name: 'professor_list'});
            this.showSuccessMsg(this.$t('common.updateSuccess'))
          })
          .catch((err) => {
            this.allErrors = err.response.data.errors;
          })
          .finally(() => {
            this.loading = false;
          });
        } else {
          this.axios.post('/professors/', formData,{
            headers: {
              'Content-Type': 'multipart/form-data'
            },
          })
          .then(() => {
            this.$router.push({name: 'professor_list'});
            this.showSuccessMsg(this.$t('common.addSuccess'))
          })
          .catch((err) => {
            this.allErrors = err.response.data.errors;
          })
          .finally(() => {
            this.loading = false;
          });
        }
    }
  }
}
</script>
